import GroupIcon from '@cp/src/assets/icons/GroupEPFOIcon';
import styles from './index.module.scss';
import AccountBalanceIcon from '@cp/src/assets/icons/AccountBalanceIcon';
import LoginIcon from '@cp/src/assets/icons/LoginIcon';
import LogoutIcon from '@cp/src/assets/icons/LogoutIcon';
import { ISherlock } from '../../interfaces/CaseDetail.type';
import dayjs from 'dayjs';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import OutLineInfoIcon from '@cp/src/assets/images/icons/OutLineInfoIcon';
import GridContainer from '@navi/web-ui/lib/layouts/Grid/GridContainer/GridContainer';
import { Button } from '@navi/web-ui/lib/primitives';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import { ClickTopCopy, copyToClipboard } from '@cp/src/utils/commonUtils';
import { useState } from 'react';
import LocationOutlineIcon from '@cp/src/assets/icons/LocationOutlineIcon';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import InfoThickIcon from '@cp/src/assets/images/icons/InfoThickIcon';

interface ISherlockProps {
  data: ISherlock;
}
const EpfoCard = (props: ISherlockProps) => {
  const { data } = props;
  const tooltipCopy = 'Click to copy';
  const tooltipArrowColor = 'var(--tooltip-background-color)';
  const formattedJoinDate = dayjs(Number(data?.joiningDate)).format('DD MMM, YYYY');
  const formattedExitDate = dayjs(Number(data?.exitDate)).format('DD MMM, YYYY');
  const formattedDate = dayjs(Number(data?.date)).format('DD MMM, YYYY');
  const [OrgNameTooltip, setOrgNameTooltip] = useState(tooltipCopy);
  const [OfficeTooltip, setOfficeTooltip] = useState(tooltipCopy);
  const [OrgNameTooltipArrow, setOrgNameTooltipArrow] = useState(tooltipArrowColor);
  const [OfficeTooltipArrow, setOfficeTooltipArrow] = useState(tooltipArrowColor);
  const handleOrganisationNameCopy = (text: string) => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_EPFO_ORGANISATION_NAME_COPY);
    ClickTopCopy({
      text: text,
      setArrowColor: setOrgNameTooltipArrow,
      setTooltipContent: setOrgNameTooltip
    });
  };
  const handleOfficeCopy = (text: string) => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_SKIPTRACING_EPFO_OFFICE_COPY);
    ClickTopCopy({
      text: text,
      setArrowColor: setOfficeTooltipArrow,
      setTooltipContent: setOfficeTooltip
    });
  };
  return data?.organisationName || data?.joiningDate || data?.exitDate ? (
    <GridContainer className={styles.cardContainer}>
      {data.isNew && <div className={styles.newContainer}>New</div>}
      <div className={styles.epfoTag}>
        <GroupIcon />
        <div className={'flex row items-center gap-[2px]'}>
          EPFO
          <Tooltip placement="bottom">
            <TooltipTrigger className="tooltipContent">
              <InfoThickIcon width={16} height={16} fillColor="var(--blue-base)" />
            </TooltipTrigger>
            <TooltipContent className="tooltipWrapper">
              {data?.infoText ? data?.infoText : 'Employment Details'}
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
      <div className={'w-[96%]'}>
        <div className={'flex justify-end absolute right-0'}>
          <div className={styles.dateContainer}>Updated on {formattedDate}</div>
        </div>
        {data?.officeAddress ? (
          <GridContainer className={styles.epfoCardContent}>
            <div className={styles.OrgContainer}>
              <div className={styles.orgName}>
                <div>
                  <AccountBalanceIcon />
                </div>
                <div className={'max-w-[270px] overflow-hidden text-ellipsis whitespace-nowrap'}>
                  {data?.organisationName ? (
                    data?.organisationName?.length > 19 ? (
                      <Tooltip
                        placement="top-start"
                        hiddenPadding={0}
                        hideStrategy="referenceHidden"
                      >
                        <TooltipTrigger className="tooltipContent" asChild={true} ellipsis>
                          <div> {data.organisationName} </div>
                        </TooltipTrigger>
                        <TooltipContent className="tooltipWrapper">
                          {data.organisationName}
                        </TooltipContent>
                      </Tooltip>
                    ) : (
                      data?.organisationName
                    )
                  ) : (
                    'NA'
                  )}
                </div>
                <span className={styles.icon}>
                  <Tooltip placement="top">
                    <TooltipTrigger className="tooltipContent">
                      <Button
                        variant="text"
                        onClick={() => handleOrganisationNameCopy(data?.organisationName || '')}
                      >
                        {data?.organisationName ? (
                          <CopyToClipboardIcon width={16} height={16} />
                        ) : null}
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent className="tooltipWrapper" arrowColor={OrgNameTooltipArrow}>
                      {OrgNameTooltip}
                    </TooltipContent>
                  </Tooltip>
                </span>
              </div>
              <div className={styles.typeOrg}>Organisation Name</div>
            </div>
            <div className={styles.OrgContainer}>
              <div className={styles.orgName}>
                <div>
                  <LocationOutlineIcon />
                </div>
                <div className={'max-w-[270px] overflow-hidden text-ellipsis whitespace-nowrap'}>
                  {data?.officeAddress?.length > 19 ? (
                    <Tooltip placement="top-start" hiddenPadding={0} hideStrategy="referenceHidden">
                      <TooltipTrigger className="tooltipContent" asChild={true} ellipsis>
                        <div> {data?.officeAddress} </div>
                      </TooltipTrigger>
                      <TooltipContent className="tooltipWrapper">
                        {data?.officeAddress}
                      </TooltipContent>
                    </Tooltip>
                  ) : (
                    data?.officeAddress
                  )}
                </div>
                <span className={styles.icon}>
                  <Tooltip placement="top">
                    <TooltipTrigger className="tooltipContent">
                      <Button
                        variant="text"
                        onClick={() => handleOfficeCopy(data?.officeAddress || '')}
                      >
                        {data?.officeAddress ? (
                          <CopyToClipboardIcon width={16} height={16} />
                        ) : null}
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent className="tooltipWrapper" arrowColor={OfficeTooltipArrow}>
                      {OfficeTooltip}
                    </TooltipContent>
                  </Tooltip>
                </span>
              </div>
              <div className={styles.typeOrg}>Office Location</div>
            </div>
            <div className={styles.joinDateContainer}>
              <div className={styles.joinDate}>
                <LoginIcon />
                {data.joiningDate ? formattedJoinDate : 'NA'}
              </div>
              <div className={styles.joinDateText}>Joining Date</div>
            </div>
          </GridContainer>
        ) : (
          <GridContainer className={styles.uanCardContent}>
            <div className={styles.OrgContainer}>
              <div className={styles.orgName}>
                <div>
                  <AccountBalanceIcon />
                </div>
                <div className={'max-w-[300px] overflow-hidden text-ellipsis whitespace-nowrap'}>
                  {data?.organisationName ? (
                    data?.organisationName?.length > 33 ? (
                      <Tooltip
                        placement="top-start"
                        hiddenPadding={0}
                        hideStrategy="referenceHidden"
                      >
                        <TooltipTrigger className="tooltipContent" asChild={true} ellipsis>
                          <div> {data.organisationName} </div>
                        </TooltipTrigger>
                        <TooltipContent className="tooltipWrapper">
                          {data.organisationName}
                        </TooltipContent>
                      </Tooltip>
                    ) : (
                      data?.organisationName
                    )
                  ) : (
                    'NA'
                  )}
                </div>
                <span className={styles.icon}>
                  <Tooltip placement="top">
                    <TooltipTrigger className="tooltipContent">
                      <Button
                        variant="text"
                        onClick={() => handleOrganisationNameCopy(data?.organisationName || '')}
                        disabled={!data?.organisationName}
                      >
                        {data?.organisationName ? (
                          <CopyToClipboardIcon width={16} height={16} />
                        ) : null}
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent className="tooltipWrapper" arrowColor={OrgNameTooltipArrow}>
                      {OrgNameTooltip}
                    </TooltipContent>
                  </Tooltip>
                </span>
              </div>
              <div className={styles.typeOrg}>Organisation Name</div>
            </div>
            <div className={styles.joinDateContainer}>
              <div className={styles.joinDate}>
                <LoginIcon />
                {data.joiningDate ? formattedJoinDate : 'NA'}
              </div>
              <div className={styles.joinDateText}>Joining Date</div>
            </div>
            <div className={styles.joinDateContainer}>
              <div className={styles.joinDate}>
                <LogoutIcon />
                {data.exitDate ? formattedExitDate : 'NA'}
              </div>
              <div className={styles.joinDateText}>Exit Date</div>
            </div>
          </GridContainer>
        )}
      </div>
    </GridContainer>
  ) : null;
};

export default EpfoCard;
